export default "__VITE_ASSET__33a5a2e6__"